/* AG Amazon Reviews - bagimsiz, dis istek yok, ~3KB.
   Sayfa ici JSON blobu uzerinde calisir: filtre, siralama, daha fazla, lightbox. */
(function () {
  'use strict';

  /* Tembel liste: kaydirma yaklastiginda ?view=agreviews cekilir, sonra normal init calisir. */
  function lazyInit(root) {
    var box = root.querySelector('[data-agr-lazy]');
    if (!box || box.__agr) return false;
    box.__agr = 1;
    var url = box.getAttribute('data-agr-lazy');
    var pulled = false;
    function pull() {
      if (pulled) return; pulled = true;
      fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html.trim()) { box.remove(); return; }
          box.innerHTML = html;
          box.removeAttribute('style');
          box.classList.add('is-loaded');
          root.__agr = 0;
          init(root);
        })
        .catch(function () { box.remove(); });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); pull(); } });
      }, { rootMargin: '500px 0px' });
      io.observe(box);
    } else { pull(); }
    return true;
  }

  function init(root) {
    if (root.__agr) return; root.__agr = 1;
    if (lazyInit(root)) return;
    var sec = root.closest('.shopify-section') || document;
    var uid = (sec.id || '').replace('shopify-section-', '');
    var blob = sec.querySelector('[data-agr-rest]');
    var tpl = sec.querySelector('[data-agr-tpl]');
    var list = root.querySelector('[data-agr-list]');
    var moreBtn = root.querySelector('[data-agr-more]');
    var empty = root.querySelector('[data-agr-empty]');
    var scope = root.dataset.scope;
    var rest = null;                                  // tembel: ilk ihtiyacta ayristirilir
    function restData() {
      if (rest === null) {
        try { rest = blob ? JSON.parse(blob.textContent) : []; } catch (e) { rest = []; }
      }
      return rest;
    }

    var ssr = list ? Array.prototype.slice.call(list.children) : [];
    var state = { star: 0, pics: false, sort: 'best', shown: ssr.length };

    /* ---- kart uretimi: SSR ile ayni markup, template klonlanarak ---- */
    function build(r) {
      if (!tpl) return null;
      var n = tpl.content.firstElementChild.cloneNode(true);
      n.dataset.r = r.r;
      n.dataset.pic = (r.p && r.p.length) ? '1' : '0';
      n.dataset.key = scope === 'collection' ? (r.ph || '') : (r.s || '');
      var sw = n.querySelector('.agr-stars');
      if (sw) { sw.style.setProperty('--agr-pct', (r.r * 20) + '%'); sw.setAttribute('aria-label', r.r + ' out of 5'); }
      var t = n.querySelector('.agr-card__date');
      if (t) { if (r.d) { t.setAttribute('datetime', r.d); t.textContent = fmt(r.d); } else { t.remove(); } }
      var ti = n.querySelector('.agr-card__title');
      if (ti) { if (r.t) { ti.textContent = r.t; } else { ti.remove(); } }
      var b = n.querySelector('.agr-card__body');
      if (b) { b.textContent = r.b || ''; }
      var mo = n.querySelector('.agr-card__more');
      if (mo && b && !b.classList.contains('is-clamped')) mo.remove();
      var au = n.querySelector('.agr-card__author'); if (au) au.textContent = r.a || '';
      var sz = n.querySelector('.agr-card__size'); if (sz) { if (r.s) sz.textContent = r.s; else sz.remove(); }
      var pr = n.querySelector('.agr-card__prod');
      if (pr) { if (r.ph) { pr.href = '/products/' + r.ph; pr.textContent = r.pt || r.ph; } else { pr.remove(); } }
      var pics = n.querySelector('.agr-card__pics');
      if (pics) {
        pics.textContent = '';
        if (r.p && r.p.length) {
          r.p.slice(0, 3).forEach(function (u) {
            var bt = document.createElement('button');
            bt.type = 'button'; bt.className = 'agr-card__pic';
            bt.setAttribute('data-agr-pic', u); bt.setAttribute('aria-label', 'Open review photo');
            var im = document.createElement('img');
            im.src = u + '&width=160'; im.width = 80; im.height = 80;
            im.loading = 'lazy'; im.decoding = 'async'; im.alt = '';
            bt.appendChild(im); pics.appendChild(bt);
          });
        } else { pics.remove(); }
      }
      return n;
    }

    var MON = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    function fmt(iso) {
      var p = String(iso).split('-'); if (p.length !== 3) return iso;
      return MON[+p[1] - 1] + ' ' + (+p[2]) + ', ' + p[0];
    }

    /* ---- filtre + siralama ---- */
    function pass(el) {
      if (state.star && +el.dataset.r !== state.star) return false;
      if (state.pics && el.dataset.pic !== '1') return false;
      return true;
    }
    function materializeAll() {
      var R = restData(), from = state.shown - ssr.length;
      if (from >= R.length) return;
      R.slice(from).forEach(function (r) { var c = build(r); if (c) list.appendChild(c); });
      state.shown = ssr.length + restData().length;
    }
    function apply() {
      var all = Array.prototype.slice.call(list.children);
      var vis = 0;
      all.forEach(function (el) { var p = pass(el); el.hidden = !p; if (p) vis++; });
      if (empty) empty.hidden = vis !== 0;
      if (moreBtn) {
        var left = (blob ? +blob.dataset.agrCount || 0 : 0) - (state.shown - ssr.length);
        moreBtn.parentNode.hidden = left <= 0 || state.star !== 0 || state.pics;
        var rm = moreBtn.querySelector('[data-agr-remain]');
        if (rm) rm.textContent = '(' + left + ')';
      }
    }
    function sortNow(mode) {
      var all = Array.prototype.slice.call(list.children);
      var key = {
        new:  function (e) { var t = e.querySelector('time'); return t ? -Date.parse(t.getAttribute('datetime')) : 0; },
        high: function (e) { return -e.dataset.r; },
        low:  function (e) { return +e.dataset.r; },
        best: function (e) { return 0; }
      }[mode] || function () { return 0; };
      if (mode !== 'best') { all.sort(function (a, b) { return key(a) - key(b); }); all.forEach(function (e) { list.appendChild(e); }); }
    }

    root.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-agr-star],[data-agr-pics],[data-agr-more],[data-agr-expand],[data-agr-pic]');
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-agr-expand')) {
        var body = t.previousElementSibling;
        if (body) { body.classList.remove('is-clamped'); t.remove(); }
        return;
      }
      if (t.hasAttribute('data-agr-pic')) { ev.preventDefault(); lightbox(t.getAttribute('data-agr-pic')); return; }
      if (t.hasAttribute('data-agr-more')) {
        var step = +t.dataset.step || 10;
        var R = restData(), from = state.shown - ssr.length;
        R.slice(from, from + step).forEach(function (r) { var c = build(r); if (c) list.appendChild(c); });
        state.shown += Math.min(step, R.length - from);
        apply(); return;
      }
      if (t.hasAttribute('data-agr-star')) {
        materializeAll();
        var s = +t.getAttribute('data-agr-star');
        state.star = (state.star === s) ? 0 : s;
        root.querySelectorAll('[data-agr-star]').forEach(function (b) {
          var v = +b.getAttribute('data-agr-star');
          b.setAttribute('aria-pressed', String(v === state.star || (v === 0 && state.star === 0)));
        });
        apply(); return;
      }
      if (t.hasAttribute('data-agr-pics')) {
        materializeAll();
        state.pics = !state.pics;
        t.setAttribute('aria-pressed', String(state.pics));
        apply(); return;
      }
    });

    var sel = root.querySelector('[data-agr-sort]');
    if (sel) sel.addEventListener('change', function () { materializeAll(); state.sort = sel.value; sortNow(sel.value); apply(); });

    /* ---- lightbox galerisi: native <dialog>, kutuphane yok ----
       Amazon deseni: oklar sayfadaki TUM yorum fotograflarini dolasir; bir
       yorumun fotograflari bitince siradaki yorumunkine gecer. Aktif yildiz
       filtresine saygi duyar.
       Onemli: galeri indeksi DOM'u DEGISTIRMEDEN kurulur (materializeAll
       cagrilmaz), boylece modal arkasindaki liste ve "Show more" butonu
       oldugu gibi kalir. Gorunur kartlar + henuz basilmamis yorum verisi
       birlestirilir; filtre/siralama zaten materializeAll cagirdigi icin
       o durumlarda hepsi DOM'da olur ve sira tutar. */
    var dlg, gal = [], gi = 0;
    var LBNAV = root.dataset.lbNav !== '0';
    var LBTXT = root.dataset.lbText !== '0';
    var LBCNT = root.dataset.lbCount !== '0';

    function picW() { return (window.innerWidth || 1200) < 700 ? 800 : 1200; }

    function buildGallery(respect) {
      var items = [], seen = Object.create(null);
      function add(u, card, r) {
        if (!u || seen[u]) return; seen[u] = 1;
        items.push({ u: u, card: card || null, r: r || null });
      }
      if (list) {
        Array.prototype.slice.call(list.children).forEach(function (card) {
          if (respect && card.hidden) return;
          card.querySelectorAll('[data-agr-pic]').forEach(function (b) {
            add(b.getAttribute('data-agr-pic'), card, null);
          });
        });
      }
      var R = restData(), from = state.shown - ssr.length;
      if (from < R.length) {
        R.slice(from).forEach(function (r) {
          if (!r.p || !r.p.length) return;
          if (respect && state.star && +r.r !== state.star) return;
          r.p.slice(0, 3).forEach(function (u) { add(u, null, r); });
        });
      }
      return items;
    }

    function idxOf(a, u) { for (var i = 0; i < a.length; i++) { if (a[i].u === u) return i; } return -1; }

    function ensureDlg() {
      if (dlg) return dlg;
      dlg = document.createElement('dialog');
      dlg.className = 'agr-lb';
      dlg.innerHTML =
        '<div class="agr-lb__box">' +
          '<div class="agr-lb__stage">' +
            '<img alt="">' +
            '<button type="button" class="agr-lb__nav agr-lb__nav--prev" aria-label="Previous photo"></button>' +
            '<button type="button" class="agr-lb__nav agr-lb__nav--next" aria-label="Next photo"></button>' +
            '<span class="agr-lb__count" aria-live="polite"></span>' +
          '</div>' +
          '<aside class="agr-lb__side"></aside>' +
        '</div>' +
        '<button type="button" class="agr-lb__x" aria-label="Close">&times;</button>';
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || e.target.closest('.agr-lb__x')) { dlg.close(); return; }
        var nv = e.target.closest('.agr-lb__nav');
        if (nv) { step(nv.classList.contains('agr-lb__nav--next') ? 1 : -1); }
      });
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      });
      var sx = null, stage = dlg.querySelector('.agr-lb__stage');
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
      }, { passive: true });
      document.body.appendChild(dlg);
      return dlg;
    }

    function step(d) {
      if (gal.length < 2) return;
      gi = (gi + d + gal.length) % gal.length;
      render();
    }

    function render() {
      var it = gal[gi], w = picW();
      dlg.querySelector('img').src = it.u + '&width=' + w;
      var many = gal.length > 1 && LBNAV;
      dlg.querySelectorAll('.agr-lb__nav').forEach(function (b) { b.hidden = !many; });
      var cn = dlg.querySelector('.agr-lb__count');
      cn.hidden = !(LBCNT && gal.length > 1);
      cn.textContent = (gi + 1) + ' / ' + gal.length;
      var side = dlg.querySelector('.agr-lb__side');
      side.textContent = '';
      if (LBTXT) {
        var src = it.card || (it.r ? build(it.r) : null);
        if (src) {
          ['.agr-card__head', '.agr-card__title', '.agr-card__body', '.agr-card__foot'].forEach(function (s) {
            var el = src.querySelector(s); if (!el) return;
            var c = el.cloneNode(true);
            c.classList.remove('is-clamped');
            side.appendChild(c);
          });
        }
      }
      side.hidden = !side.firstChild;
      if (gal.length > 1) {
        [gal[(gi + 1) % gal.length], gal[(gi - 1 + gal.length) % gal.length]].forEach(function (n) {
          if (n && n.u !== it.u) { var p = new Image(); p.src = n.u + '&width=' + w; }
        });
      }
    }

    function lightbox(url) {
      gal = buildGallery(true);
      gi = idxOf(gal, url);
      if (gi < 0) { gal = buildGallery(false); gi = idxOf(gal, url); }
      if (gi < 0) { gal = [{ u: url, card: null, r: null }]; gi = 0; }
      ensureDlg();
      render();
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    }
    apply();
  }

  function boot() { document.querySelectorAll('[data-agr-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);


  /* Parent sayfasinda bir kategori kutusu secilince, o kategorinin
     tum yorumlarina kisayol goster. Ek veri cekmez, sadece link kurar. */
  document.addEventListener('click', function (e) {
    var tile = e.target.closest('[data-airgrilles-qo3-tile]');
    if (!tile) return;
    var jump = document.querySelector('[data-agr-jump]');
    if (!jump) return;
    var url = tile.getAttribute('data-sub-url');
    var t = tile.querySelector('.airgrilles-qo3-parent__tile-title');
    var rate = tile.querySelector('.agr-tile-rate__n');
    if (!url || !t) { jump.hidden = true; return; }
    var n = rate ? rate.textContent.replace(/[()]/g, '') : '';
    jump.href = url + '#ag-reviews';
    jump.textContent = n
      ? 'See all ' + n + ' reviews for ' + t.textContent.trim() + ' \u2192'
      : 'See reviews for ' + t.textContent.trim() + ' \u2192';
    jump.hidden = false;
  });

  /* rozet -> section yumusak kaydirma */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-agr-scroll]');
    if (!a) return;
    var el = document.querySelector(a.getAttribute('href'));
    if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
})();
